<div class="dialog-header" [class.dialog-header--narrow-padding]="narrowPadding()" mat-dialog-title>
  <ng-content />

  <button mat-icon-button (click)="closeDialog.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>
